module.exports = __webpack_public_path__ + "static/media/chevron_up_Gray.9ed4789f.svg";